module.exports = __webpack_public_path__ + "static/media/OrangeLogo.cb8edecc.png";